/**
 * Translations for SDK UI elements
 */

import type { Locale } from '../types';

export const SUPPORTED_LOCALES: Locale[] = ['en', 'de', 'es', 'fr', 'it', 'nl', 'pl', 'pt'];

export const DEFAULT_LOCALE: Locale = 'en';

export interface DisclaimerTranslation {
  text: string;
}

export const DISCLAIMER_TRANSLATIONS: Record<Locale, DisclaimerTranslation> = {
  en: {
    text: 'Secured and processed by our Merchant of Record, <strong>Inflowpay</strong>, <br>who also handles order-related inquiries and returns',
  },
  de: {
    text: 'Gesichert und verarbeitet von unserem Merchant of Record, <strong>Inflowpay</strong>, <br>der auch auftragsbezogene Anfragen und Rücksendungen bearbeitet',
  },
  es: {
    text: 'Protegido y procesado por nuestro Merchant of Record, <strong>Inflowpay</strong>, <br>que también maneja consultas y devoluciones relacionadas con el pedido',
  },
  fr: {
    text: 'Sécurisé et traité par notre Merchant of Record, <strong>Inflowpay</strong>, <br>qui gère également les demandes et retours liés aux commandes',
  },
  it: {
    text: 'Protetto ed elaborato dal nostro Merchant of Record, <strong>Inflowpay</strong>, <br>che gestisce anche richieste e resi relativi agli ordini',
  },
  nl: {
    text: 'Beveiligd en verwerkt door onze Merchant of Record, <strong>Inflowpay</strong>, <br>die ook ordergerelatereerde vragen en retouren afhandelt',
  },
  pl: {
    text: 'Zabezpieczone i przetwarzane przez Merchant of Record, <strong>Inflowpay</strong>, <br>który również obsługuje zapytania i zwroty związane z zamówieniami',
  },
  pt: {
    text: 'Protegido e processado pelo nosso Merchant of Record, <strong>Inflowpay</strong>, <br>que também trata de consultas e devoluções relacionadas ao pedido',
  },
};

export function getDisclaimerText(locale?: Locale | string): string {
  const validLocale = isValidLocale(locale) ? locale : DEFAULT_LOCALE;
  return DISCLAIMER_TRANSLATIONS[validLocale].text;
}

export function isValidLocale(locale?: string): locale is Locale {
  return !!locale && SUPPORTED_LOCALES.includes(locale as Locale);
}

export function detectBrowserLocale(): Locale {
  if (typeof navigator === 'undefined') {
    return DEFAULT_LOCALE;
  }

  const browserLang = navigator.language || (navigator as any).userLanguage || '';
  const primaryLang = browserLang.split('-')[0].toLowerCase();

  if (isValidLocale(primaryLang)) {
    return primaryLang;
  }

  return DEFAULT_LOCALE;
}
